import * as React from 'react';

import { IValidationResponse } from '../../../AdminPortal/Features/Common/IValidationResponse.csharp';
import { SkuMultiSelect } from '../../../AdminPortal/Features/Components/SkuMultiSelect/SkuMultiSelect';
import { CheckboxInput } from './CheckboxInput';
import { FormInput } from './FormInput';
import { FormField, FormFields, PostalCodeAndCityFormField, ValidationIssue } from './FormInterfaces';
import { PostalCodeFormInput } from './PostalCodeFormInput';

interface FormFieldsProps {
    validateOnInit?: boolean;
    inputs: FormFields;
    onChange: (value: string | number | boolean, name: string, errors: ValidationIssue[]) => void;
    setWasActive: (name: string) => void;
    collapseInput: (value: boolean, name: string) => void;
    getProductSkusUrl?: string;
    autocompleteUrl?: string;
    validate?: (skus: string[]) => Promise<IValidationResponse>;
    // eslint-disable-next-line
    dependencies?: any[];
    afterValidateItems?: (validationResponse: IValidationResponse) => void;
}

export const FormInputs = (props: FormFieldsProps) => {
    const { inputs, onChange, setWasActive, autocompleteUrl, collapseInput, getProductSkusUrl, validate, dependencies, afterValidateItems } = props;

    const isConfigurationForPostalCodeAndCityInputValid = (input: PostalCodeAndCityFormField): boolean => {
        let isValid = true;
        if (!props.autocompleteUrl) {
            console.error("For 'postalCodeAndCity' type you need to provide 'autocompleteUrl' props");
            isValid = false;
        }
        if (!inputs.hasOwnProperty(input.city) || !inputs.hasOwnProperty(input.postalCode)) {
            console.error("For 'postalCodeAndCity' type you need to provide 'city' and 'postalCode' FormFields in configuration with type 'hidden");
            isValid = false;
        }

        return isValid;
    };

    const handlePostalCodeAndCityInput = (input: FormField, name: string) => {
        if (input.type !== 'postalCodeAndCity') return null;
        const postalCodeAndCityFormField = input as PostalCodeAndCityFormField;

        if (!postalCodeAndCityFormField || !isConfigurationForPostalCodeAndCityInputValid(postalCodeAndCityFormField)) return null;

        // doesn't have validateOnInit as it has an issue with being invalid even on touch (without modifying value)
        return (
            <PostalCodeFormInput
                key={input.displayName}
                name={name}
                input={postalCodeAndCityFormField}
                inputs={inputs}
                autocompleteUrl={autocompleteUrl || ''}
                value={input.value}
                setValue={props.onChange}
                setWasActive={setWasActive}
            />
        );
    };

    return (
        <>
            {Object.entries(inputs).map((entry) => {
                switch (entry[1].type) {
                    case 'postalCodeAndCity':
                        return handlePostalCodeAndCityInput(entry[1], entry[0]);
                    case 'multipleSelect':
                        return (
                            <SkuMultiSelect
                                input={entry[1]}
                                getProductSkusUrl={getProductSkusUrl!}
                                dependencies={dependencies}
                                validate={validate!}
                                afterValidateItems={afterValidateItems}
                                onChange={onChange}
                                inputName={entry[0]}
                                key={entry[0]}
                            />
                        );
                    case 'checkbox':
                        return <CheckboxInput input={entry[1]} inputs={inputs} name={entry[0]} value={entry[1].value} key={entry[0]} onChange={onChange} />;
                    default:
                        return (
                            <FormInput
                                input={entry[1]}
                                inputs={inputs}
                                name={entry[0]}
                                onChange={onChange}
                                setWasActive={setWasActive}
                                key={entry[0]}
                                validateOnInit={props.validateOnInit}
                                collapseInput={collapseInput}
                            />
                        );
                }
            })}
        </>
    );
};
